var React = require('react');

function Integral (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M377.21 73a32.71 32.71 0 0 1-4.84 45l-24.18 20a30.29 30.29 0 0 1-43.52-5l-28-36.2-79.2 339.11C186.5 485 141.92 517.8 92.1 511.13c-25.36-3.39-47.91-18.58-63.89-39.21L6.79 444.27a32.73 32.73 0 0 1 4.82-45l24.17-20a30.3 30.3 0 0 1 43.53 5l24 30.91 78.11-334.36C190.54 40 221.86 6.41 262.05.89c33.82-4.64 66.38 9.09 87.16 36z","className":"fa-secondary","key":1})]);
}

Integral.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Integral;

Integral.default = Integral;
